import React, { Component } from 'react'

class Investigators extends Component {
    render(){
        return(
            <div className=' w3-container my-profile-container'>
                <h4 className='w3-center'><b>Project Investigators</b></h4>
                <div className=' w3-row w3-card-2 w3-white w3-round-large w3-center w3-margin-bottom'>
                    <div className='w3-quarter w3-padding'>
                        <img src='./images/barjeev.png' className='my-card-img' alt='barjeev' />
                    </div>
                    <div className='w3-threequarter w3-padding'>
                    <table className="w3-table-all"  >
                            <thead>
                            <tr  className=" w3-bottombar w3-border-blue">
                                <th className="w3-center w3-large my-table-heading" colSpan='2'>Dr. Barjeev Tyagi</th>
                                
                                
                            </tr>
                            </thead>
                            <tbody>
                            <tr>
                                <td><b>Institute:</b></td>
                                <td> IIT Roorkee, India</td>
                               
                            </tr>
                            <tr>
                                <td><b>Department:</b></td>
                                <td> Electrical Engineering Department</td>
                               
                            </tr>
                            <tr>
                                <td><b>Contribution:</b></td>
                                <td> Identification of space for Lab setup, Development of Lab setup, Development of battery room, selection of PV Panels, Configuration of PV Panels, Different types of load Identification, Integration of Battery, solar and AC sources, Modeling and Design of online UPS(120kW) System, Modeling ad Design of Grid Connected Inverters(GCI), Integration of Online UPS with GCI, Identification and Analysis of switching Transients.</td>
                            </tr>
                            <tr>
                                <td><b>Role:</b></td>
                                <td>PI</td>
                                
                            </tr>
                            <tr>
                                <td><b>More Detail:</b></td>
                                <td> <a href='https://ee.iitr.ac.in/~EE/btyagfee'>click here...</a></td>
                            </tr>
                            </tbody>
                        </table>  
                    </div>
                </div>
                <div className=' w3-row w3-card-2 w3-white w3-round-large w3-center w3-margin-bottom'>
                    <div className='w3-quarter w3-padding'>
                        <img src='./images/vishal.png' className='my-card-img' alt='vishal' />
                    </div>
                    <div className='w3-threequarter w3-padding'>
                    <table className="w3-table-all"  >
                            <thead>
                            <tr  className=" w3-bottombar w3-border-blue">
                                <th className="w3-center w3-large my-table-heading" colSpan='2'>Dr. Vishal Kumar</th>
                                
                                
                            </tr>
                            </thead>
                            <tbody>
                            <tr>
                                <td><b>Institute:</b></td>
                                <td> IIT Roorkee, India</td>
                               
                            </tr>
                            <tr>
                                <td><b>Department:</b></td>
                                <td> Electrical Engineering Department</td>
                               
                            </tr>
                            <tr>
                                <td><b>Contribution:</b></td>
                                <td> Battery Specification, Installation of Battery, Analysis of Lab Data, Analysis of Field Demonstration Data, Design of Controllers for Online UPS and GCI, Controller Design to minimize switching transients</td>
                            </tr>
                            <tr>
                                <td><b>Role:</b></td>
                                <td>Co-PI</td>
                                
                            </tr>
                            <tr>
                                <td><b>More Detail:</b></td>
                                <td> <a href='https://ee.iitr.ac.in/~EE/vksaxfee'>click here...</a></td>
                            </tr>
                            </tbody>
                        </table>  
                    </div>
                </div>
                <div className=' w3-row w3-card-2 w3-white w3-round-large w3-center w3-margin-bottom'>
                    <div className='w3-quarter w3-padding'>
                        <img src='./images/pramod.png' className='my-card-img' alt='pramod' />
                    </div>
                    <div className='w3-threequarter w3-padding'>
                    <table className="w3-table-all"  >
                            <thead>
                            <tr  className=" w3-bottombar w3-border-blue">
                                <th className="w3-center w3-large my-table-heading" colSpan='2'>Dr. Pramod Agarwal</th>
                                
                                
                            </tr>
                            </thead>
                            <tbody>
                            <tr>
                                <td><b>Institute:</b></td>
                                <td > IIT Roorkee, India</td>
                               
                            </tr>
                            <tr>
                                <td><b>Department:</b></td>
                                <td > Electrical Engineering Department</td>
                               
                            </tr>
                            <tr>
                                <td><b>Contribution:</b></td>
                                <td > Battery Testing, Master Inverter Design, Different types of Converter Selection, Different Equipment's testing</td>
                            </tr>
                            <tr>
                                <td><b>Role:</b></td>
                                <td>Co-PI</td>
                                
                            </tr>
                            <tr>
                                <td><b>More Detail:</b></td>
                                <td><a href="https://ee.iitr.ac.in/~EE/pramgfee">Click Here...</a></td>
                            </tr>
                            </tbody>
                        </table>  
                    </div>
                </div>
                <div className=' w3-row w3-card-2 w3-white w3-round-large w3-center w3-margin-bottom'>
                    <div className='w3-quarter w3-padding'>
                        <img src='./images/pawan.png' className='my-card-img' alt='pawan' />
                    </div>
                    <div className='w3-threequarter w3-padding'>
                    <table className="w3-table-all"  >
                            <thead>
                            <tr  className=" w3-bottombar w3-border-blue">
                                <th className="w3-center w3-large my-table-heading" colSpan='2'>Dr. Pawan Sharma</th>
                                
                                
                            </tr>
                            </thead>
                            <tbody>
                            <tr>
                                <td><b>Institute:</b></td>
                                <td > UiT, Norway</td>
                               
                            </tr>
                            <tr>
                                <td><b>Department:</b></td>
                                <td > Electrical Engineering Department</td>
                               
                            </tr>
                            <tr>
                                <td><b>Contribution:</b></td>
                                <td >Modeling of SPV, Mdeling of Battery, Modeling of AC Source, Integration of Battery, Solar and AC Sources, Modeling and Design of online UPS(120kW) system, Modeling and Design of Grid Connected Inverter(GCI), Integration of Onlne UPS with GCI, Identification and Analysis of Switching Transients</td>
                            </tr>
                            <tr>
                                <td><b>Role:</b></td>
                                <td>PI</td>
                                
                            </tr>
                            <tr>
                                <td><b>More Detail:</b></td>
                                <td><a href="https://en.uit.no/ansatte/pawan.sharma">Click Here...</a></td>
                            </tr>
                            </tbody>
                        </table>  
                    </div>
                </div>
                <div className=' w3-row w3-card-2 w3-white w3-round-large w3-center w3-margin-bottom'>
                    <div className='w3-quarter w3-padding'>
                        <img src='./images/bhagwan.png' className='my-card-img' alt='bhagwan' />
                    </div>
                    <div className='w3-threequarter w3-padding'>
                    <table className="w3-table-all"  >
                            <thead>
                            <tr  className=" w3-bottombar w3-border-blue">
                                <th className="w3-center w3-large my-table-heading" colSpan='2'>Dr. D. Bhagwan Das </th>
                                
                                
                            </tr>
                            </thead>
                            <tbody>
                            <tr>
                                <td><b>Institute:</b></td>
                                <td > DEI Agra, India</td>
                               
                            </tr>
                            <tr>
                                <td><b>Department:</b></td>
                                <td > Electrical Engineering Department</td>
                               
                            </tr>
                            <tr>
                                <td><b>Contribution:</b></td>
                                <td > Foundation and fabrication work, Fixing of Solar modules, underground cabling, Inverter Commissioning, VRF battery commissioning and DC Microgrid, Integration of Online UPS with GCI, Design of Controllers for online UPS and GCI, Integration of Bio-gas Plant, Identification and Analysis of Switchig transients, Controller Design for optimal end use of Slar power, Remote monitoring, performance analysis, analytics for efficient operation</td>
                            </tr>
                            <tr>
                                <td><b>Role:</b></td>
                                <td>PI</td>
                                
                            </tr>
                            <tr>
                                <td><b>More Detail:</b></td>
                                <td><a href="https://www.dei.ac.in/dei/engineering/index.php/2012-12-08-09-23-43/electrical-engg-faculty/17-electrical-engineering-faculty/68-prof-d-bhagwan-das">Click Here...</a></td>
                            </tr>
                            </tbody>
                        </table>  
                    </div>
                </div>
                <div className=' w3-row w3-card-2 w3-white w3-round-large w3-center w3-margin-bottom'>
                    <div className='w3-quarter w3-padding'>
                        <img src='./images/saxena.png' className='my-card-img' alt='saxena' />
                    </div>
                    <div className='w3-threequarter w3-padding'>
                    <table className="w3-table-all"  >
                            <thead>
                            <tr  className=" w3-bottombar w3-border-blue">
                                <th className="w3-center w3-large my-table-heading" colSpan='2'>Dr. A. K. Saxena</th>
                                
                                
                            </tr>
                            </thead>
                            <tbody>
                            <tr>
                                <td><b>Institute:</b></td>
                                <td > DEI Agra, India</td>
                               
                            </tr>
                            <tr>
                                <td><b>Department:</b></td>
                                <td > Electrical Engineering Department</td>
                               
                            </tr>
                            <tr>
                                <td><b>Contribution:</b></td>
                                <td > Foundation and fabrication work, Fixing of Solar modules, Inverter Commissioning, VRF battery commissioning and DC Microgrid, Design & fabrication of electric thrasher, reaper, cultivator, Design & fabrication of electric chiller system for Dairy,  Integration of Online UPS with GCI, Design of Controllers for online UPS and GCI, Integration of Bio-gas Plant</td>
                            </tr>
                            <tr>
                                <td><b>Role:</b></td>
                                <td>Co-PI</td>
                                
                            </tr>
                            <tr>
                                <td><b>More Detail:</b></td>
                                <td><a href="https://www.dei.ac.in/dei/engineering/index.php/2012-12-08-09-23-43/electrical-engg-faculty/17-electrical-engineering-faculty/66-prof-ajay-kumar-saxena">Click Here...</a></td>
                            </tr>
                            </tbody>
                        </table>  
                    </div>
                </div>
                <div className=' w3-row w3-card-2 w3-white w3-round-large w3-center w3-margin-bottom'>
                    <div className='w3-quarter w3-padding'>
                        <img src='./images/babu.png' className='my-card-img' alt='babu' />
                    </div>
                    <div className='w3-threequarter w3-padding'>
                    <table className="w3-table-all"  >
                            <thead>
                            <tr  className=" w3-bottombar w3-border-blue">
                                <th className="w3-center w3-large my-table-heading" colSpan='2'>Dr. G. S. Sailesh Babu</th>
                                
                                
                            </tr>
                            </thead>
                            <tbody>
                            <tr>
                                <td><b>Institute:</b></td>
                                <td > DEI Agra, India</td>
                               
                            </tr>
                            <tr>
                                <td><b>Department:</b></td>
                                <td > Electrical Engineering Department</td>
                               
                            </tr>
                            <tr>
                                <td><b>Contribution:</b></td>
                                <td > Foundation and fabrication work, Fixing of Solar modules, Inverter Commissioning, VRF battery commissioning and DC Microgrid, Design & fabrication of electric thrasher, reaper, cultivator, Design & fabrication of electric chiller system for Dairy, Identification and analysis of switching transients, controller design for optimal end use of solar power, remote monitoring, performance analysis, analytics for efficient operation</td>
                            </tr>
                            <tr>
                                <td><b>Role:</b></td>
                                <td>Co-PI</td>
                                
                            </tr>
                            <tr>
                                <td><b>More Detail:</b></td>
                                <td><a href="https://www.dei.ac.in/dei/engineering/index.php/2012-12-08-09-23-43/electrical-engg-faculty/17-electrical-engineering-faculty/58-dr-g-s-sailesh-babu">Click Here...</a></td>
                            </tr>
                            </tbody>
                        </table>  
                    </div>
                </div>
                <div className=' w3-row w3-card-2 w3-white w3-round-large w3-center w3-margin-bottom'>
                    <div className='w3-quarter w3-padding'>
                        <img src='./images/rana.png' className='my-card-img' alt='rana' />
                    </div>
                    <div className='w3-threequarter w3-padding'>
                    <table className="w3-table-all"  >
                            <thead>
                            <tr  className=" w3-bottombar w3-border-blue">
                                <th className="w3-center w3-large my-table-heading" colSpan='2'>Mr. Gaurav Pratap Rana</th>
                                
                                
                            </tr>
                            </thead>
                            <tbody>
                            <tr>
                                <td><b>Institute:</b></td>
                                <td > DEI Agra, India</td>
                               
                            </tr>
                            <tr>
                                <td><b>Department:</b></td>
                                <td > Electrical Engineering Department</td>
                               
                            </tr>
                            <tr>
                                <td><b>Contribution:</b></td>
                                <td > Foundation and fabrication work, Fixing of Solar modules, Inverter Commissioning, VRF battery commissioning and DC Microgrid, Design & fabrication of electric thrasher, reaper, cultivator, Design & fabrication of electric chiller system for Dairy,  Integration of Online UPS with GCI, Design of Controllers for online UPS and GCI, Integration of Bio-gas Plant</td>
                            </tr>
                            <tr>
                                <td><b>Role:</b></td>
                                <td>Co-PI</td>
                                
                            </tr>
                            <tr>
                                <td><b>More Detail:</b></td>
                                <td><a href="https://www.dei.ac.in/dei/engineering/index.php/2012-12-08-09-23-43/electrical-engg-faculty/17-electrical-engineering-faculty/107-mr-g-p-rana">Click Here...</a></td>
                            </tr>
                            </tbody>
                        </table>  
                    </div>
                </div>


            </div>
        )
    }
}

export default Investigators